import _ from 'lodash';
import { StateService } from '@/services/state.service';
import { FrameworkService } from '@/services/framework.service';
import { RulesServiceConfig } from '@/services/rules.service.config';
import { Helpers } from '@/common/helpers';
import { RuleNames } from './rules.service.config';

export const RulesService = {
	initialized: false,
	rulesProfile: {
		availableClubs: [],
		memberLevel: 0,
		isAuthenticated: false
	},
	mockFailure: null,

	initialize() {
		if (!this.initialized) {

			this.rulesProfile.availableClubs = FrameworkService.data('profile.availableClubs');
			this.rulesProfile.memberLevel = Helpers.levelToInt(FrameworkService.data('profile.membershipLevelGroupName'));
			this.rulesProfile.isAuthenticated = (StateService.getSSOToken() || '') !== '';

			if (StateService.isMockData()) {
				this.mockFailure = StateService.getQuery('mockFailure');
			}
		}
		return Promise.resolve(true);
	},

	getExtraConditions(rules) {
		const conditions = {
			specialRequirements: [],
			participantsMinimum: 1
		};

		if (rules) {
			for (const ruleName of _.keys(rules)) {
				const rule = rules[ruleName];
				if (!rule) continue;
				if (rule.specialCondition) {
					conditions.specialRequirements.push(rule.specialCondition);
				}
				if (rule.minAttendees && rule.participantsMinimum > conditions.minAttendees) {
					conditions.participantsMinimum = rule.minAttendees;
				}
			}
		}
		return conditions;
	},

	validateClient(
		rules,
		// regValues is the contextual parameter object that will be somewhat unique per implementation.
		regValues,
		// ruleType and ruleState drive which rules will be validated
		ruleType,
		ruleState,
		// Some rules won't be defined in the RegApi rules, so if we want to run additional rules, their names are passed in the additionalRules array
		additionalRules
	) {
		const params = {
			profile: this.rulesProfile,
			rule: {},
			reg: regValues || {}
		};

		const result = [];
		const _mockFailure = this.mockFailure;

		_.forEach(additionalRules || [], function(extraRule) {
			params.rule = {};
			const errorMessage = runRule(extraRule, ruleType, ruleState, params, _mockFailure);
			if (errorMessage) {
				result.push({
					from: 'client',
					name: extraRule,
					message: errorMessage
				});
			}
		});

		if (rules) {
			for (const ruleName of _.keys(rules)) {
				params.rule = rules[ruleName];
				const errorMessage = runRule(ruleName, ruleType, ruleState, params, _mockFailure);
				if (errorMessage) {
					result.push({
						from: 'client',
						name: ruleName,
						message: errorMessage
					});
				}
			}
		}

		return result;
	},

	validateServer(serverErrors) {
		const result = [];
		for (const error of serverErrors) {
			const errorCode = RulesServiceConfig.getRuleNameFromServerError(error.reason);
			if (errorCode) {
				result.push({
					from: 'server',
					name: errorCode,
					message: error.message
				});
			}
		}
		return result;
	},

	notAuthenticated(validationResults) {
		const notAuth = _.find(validationResults, function(r) {
			return r.name === RuleNames.authenticated;
		});
		return notAuth ? true : false;
	}
};

function runRule(ruleName, ruleType, ruleState, params, mockFailure) {
	const rule = RulesServiceConfig.getRule(ruleName, ruleType, ruleState);
	if (rule) {
		let result = rule.validate(params);
		if (mockFailure && ruleName === mockFailure) {
			result = {
				success: false,
				errorParams: {}
			};
			const errorReturn = params.rule.errorMessage || rule.error(result.errorParams);
			return errorReturn || 'Mock Error Failure: ' + ruleName;
		}
		if (result.success) return '';
		return params.rule.errorMessage || rule.error(result.errorParams);
	}
	return null;
}



